import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useActivityRunsQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectRobotRunId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();
  // const { pathParameters, setPathParameter } = useContext(ApiHelperContext);

  const { data: activityRuns = [], isInitialLoading: isLoadingStepRuns } = useActivityRunsQuery(
    {
      processId: pathParameters.process_id as string,
      processRunId: pathParameters.process_run_id as string,
    },
    { enabled: !!(pathParameters.process_id && pathParameters.process_run_id) },
  );

  const robotRunItems = useMemo(
    () =>
      activityRuns.map((item, index) => ({
        label: `${item.activityName} #${index}`,
        value: item.id,
      })),
    [activityRuns],
  );

  return (
    <ApiHelperSelectInput
      label={t('stepRun.choose')}
      items={robotRunItems}
      value={value}
      onChange={(value) => setValue('step_run_id', value)}
      loading={isLoadingStepRuns}
      {...props}
    />
  );
};
